import Info from "./Info";
import List from "./List";
import Options from "./Options";
export default {
    Info,
    List,
    Options
}

